import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { StudNewComponent } from './stud-new/stud-new.component';
import { FormsModule,ReactiveFormsModule} from '@angular/forms';
import { HsscstudentComponent } from './hsscstudent/hsscstudent.component';
import { NavabrComponent } from './shared/navabr/navabr.component';
import { DataTablesModule } from 'angular-datatables';
import { HttpClientModule } from '@angular/common/http';
import { HomeComponent } from './home/home.component';
import { LandingComponent } from './landing/landing.component';
import { LoginComponent } from './login/login.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { FooterComponent } from './shared/footer/footer.component';
import { PrintDataComponent } from './print-data/print-data.component';
import { DatePipe } from '@angular/common';
import { ChangepasswordComponent } from './changepassword/changepassword.component';



@NgModule({
  declarations: [
    AppComponent,
    StudNewComponent,
    HsscstudentComponent,
    NavabrComponent,
    HomeComponent,
    LandingComponent,
    LoginComponent,
    FooterComponent,
    PrintDataComponent,
    ChangepasswordComponent,
    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    DataTablesModule,
    HttpClientModule,
    FormsModule,
    NgxCaptchaModule,
    ReactiveFormsModule
    
  ],
  providers: [
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
